module.exports = __webpack_public_path__ + "static/animated-illustration-2-3d87416f93e1abddbf290e249bcb78e4.gif";